/**
 * @file FreeFaqContent.tsx
 * @description Component displaying FAQ content for free users.
 */

import React from "react";
import GenerateContentButton from "../../components/common/GenerateContentButton";

const FreeFaqContent: React.FC = () => {
  return (
    <section className="flex flex-col items-center gap-4 p-6 mx-auto bg-base-100 rounded-3xl xl:p-12 w-fit text-lg relative">
      <h3 className="!mb-2 !text-4xl text-primary !font-normal">
        Cosa puoi fare
      </h3>
      <p>
        Il Free Plan ti consente di generare fino a 4 contenuti SEO ogni mese.
      </p>
      <GenerateContentButton />
    </section>
  );
};

export default FreeFaqContent;
